import { Suspense, lazy } from 'react'
import { Routes, Route } from 'react-router-dom'
import { Toaster } from '@/components/ui/toaster'
import { DebugControlsProvider } from '@/components/debug-controls-context'
import { ContactOverlayProvider } from '@/components/contact-overlay-context'
import { CancellationOverlayProvider } from '@/components/cancellation-overlay-context'
import { LayoutChrome } from '@/components/layout-chrome'
import { ScrollToTop } from '@/components/scroll-to-top'
import { AppLoader } from '@/components/ui/app-loader'

// Pages
import HomePage from '@/pages/Home'
const KursplanPage = lazy(() => import('@/pages/Kursplan'))
const ReformerPilatesPage = lazy(() => import('@/pages/ReformerPilates'))
const LegalPage = lazy(() => import('@/pages/Legal'))
const KontaktPage = lazy(() => import('@/pages/Kontakt'))
const StudioPage = lazy(() => import('@/pages/Studio'))
const NotFoundPage = lazy(() => import('@/pages/NotFound'))
import AdminLayout from '@/pages/admin/AdminLayout'
const AdminDashboard = lazy(() => import('@/pages/admin/Dashboard'))
const AdminInquiriesPage = lazy(() => import('@/pages/admin/Inquiries'))
const AdminOffersPage = lazy(() => import('@/pages/admin/Offers'))
const AdminCoursesPage = lazy(() => import('@/pages/admin/Courses'))
const AdminKursplanPage = lazy(() => import('@/pages/admin/Kursplan'))
const AdminWellnessPage = lazy(() => import('@/pages/admin/Wellness'))
const AdminOpeningHoursPage = lazy(() => import('@/pages/admin/OpeningHours'))
const AdminPackagesPage = lazy(() => import('@/pages/admin/Packages'))
const AdminSonstigesPage = lazy(() => import('@/pages/admin/Sonstiges'))
const AdminHeroPage = lazy(() => import('@/pages/admin/Hero'))
const AdminMitarbeiterPage = lazy(() => import('@/pages/admin/Mitarbeiter'))
const AdminLoginPage = lazy(() => import('@/pages/admin/Login'))

const standaloneRouteFallback = <AppLoader className="min-h-screen" />

function App() {
  return (
    <DebugControlsProvider>
      <ContactOverlayProvider>
        <CancellationOverlayProvider>
          <ScrollToTop />
          <Suspense fallback={standaloneRouteFallback}>
            <Routes>
              {/* Main routes with layout */}
              <Route element={<LayoutChrome />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/kursplan" element={<KursplanPage />} />
                <Route path="/reformer-pilates" element={<ReformerPilatesPage />} />
                <Route path="/legal/:slug" element={<LegalPage />} />
                <Route path="/kontakt" element={<KontaktPage />} />
                <Route path="/studio/:slug" element={<StudioPage />} />
              </Route>

              {/* Admin routes */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="inquiries" element={<AdminInquiriesPage />} />
                <Route path="offers" element={<AdminOffersPage />} />
                <Route path="courses" element={<AdminCoursesPage />} />
                <Route path="kursplan" element={<AdminKursplanPage />} />
                <Route path="wellness" element={<AdminWellnessPage />} />
                <Route path="opening-hours" element={<AdminOpeningHoursPage />} />
                <Route path="packages" element={<AdminPackagesPage />} />
                <Route path="sonstiges" element={<AdminSonstigesPage />} />
                <Route path="hero" element={<AdminHeroPage />} />
                <Route path="mitarbeiter" element={<AdminMitarbeiterPage />} />
              </Route>

              {/* 404 */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
          <Toaster />
        </CancellationOverlayProvider>
      </ContactOverlayProvider>
    </DebugControlsProvider>
  )
}

export default App
